import React, { useContext, useEffect, useState } from 'react'
import {
  BuyingInsuranceContextStore,
  unbundleBodilyLiabilityToOtherLiabilityCoverages,
  unbundleBodilyLiabilityToOtherLiabilityCoveragesNewFlow,
} from '../../../context/BuyingInsuranceContext'
import { SessionContextStore } from '../../../context/SessionContext'
import { SectionSpecialSelect } from '../../Core/Form/FormComponents'
import { ShieldIcon, MotorcycleIcon, HelpIcon } from './assets'
import { Tooltip } from './components'
import {
  coveragesToIgnore,
  policyCoverageOrder,
  PolicyCoveragesMapping,
  policyCoverageThatUnderMotorcyclesOrder,
} from '../../../models/insurance-models/CoveragesMapping'
import './styles.scss'
import { MotorcycleCoveragesForm } from '../../Motorcycle/MotorcycleCoveragesForm'
import { Divider } from '@material-ui/core'
import { createOfferCart, getCoverageTooltip } from './utils'
import TotalCard from './TotalCard'
import { awaitWithLoading } from '../../../services/utils'
import { parseOfferViolations } from '../../../utilities/ParseOfferViolations'
import { BillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel'
import coveragesApi from '../../../api/coverages.api'
import _ from 'lodash'
import { statesWithLiabilityTripleBundle } from '../../../Constants'

export default ({ offer, options, addOnCoverages, startTime, billingPeriodOffer, setOpen }) => {
  const offersContext = useContext(BuyingInsuranceContextStore)
  const sessionContext = useContext(SessionContextStore)
  const vehicles = sessionContext.user.userVehicles
  const offerCart = createOfferCart(offer)
  const [cart, setCart] = useState(offerCart)
  const [offerPriceBreakdown, setofferPriceBreakdown] = useState({})
  const [vehicleDetails, setVehicleDetails] = useState({})
  const [cartErrors, setOfferCartErrors] = useState({})
  const [cartWarnings, setOfferCartWarnings] = useState({
    violationsId: [],
  })
  const [billingPeriod, setBillingPeriod] = useState(billingPeriodOffer)

  const onPolicyFieldChange = (name, value) => {
    let changed = { ...cart }
    changed[name] = value
    updateCart(changed)
  }

  const onDiminishingDeductibleChange = (motorcycleId, value) => {
    let changed = { ...cart }
    changed.vehicle_requests[motorcycleId].is_diminishing_deductible = value
    setCart(changed)
  }

  const onMotorcycleChange = (motorcycleId, name, value) => {
    let changed = { ...cart }
    changed.vehicle_requests[motorcycleId].coverages[name] = value
    setCart(changed)
  }

  const updateCart = cart => {
    if (statesWithLiabilityTripleBundle.includes(sessionContext.user.administrativeDivision)) {
      unbundleBodilyLiabilityToOtherLiabilityCoverages(cart, options)
    } else {
      unbundleBodilyLiabilityToOtherLiabilityCoveragesNewFlow(cart, options)
    }
    setCart(cart)
  }

  const requestOffer = async (cart, startTime, billingPeriod, options) => {
    const { vehicle_requests, ...offer } = cart
    if (vehicle_requests == undefined || Object.keys(vehicle_requests).length === 0 || Object.keys(offer).length === 0) return

    if (billingPeriod == undefined) {
      setBillingPeriod(BillingPeriod.MONTH)
    }

    const coverages = {}
    for (const [key, value] of Object.entries(offer)) {
      coverages[key] = {
        option_id: value,
        is_stackable: options[key].is_stackable,
      }
    }
    const res = await awaitWithLoading(
      coveragesApi.requestOffer({
        start_time: startTime,
        coverages: coverages,
        vehicle_requests,
        billing_period: billingPeriod,
      })
    )

    if (res.ok) {
      setofferPriceBreakdown(res.data)
      setOfferCartErrors({})
      setVehicleDetails(res.data.vehiclesDetailsForUi)
      setBillingPeriod(res.data.billingPeriod)
    }
    if (res.data && res.data.code == 400) {
      let errors = parseOfferViolations(res.data)
      setOfferCartErrors(errors)
    } else if (res.status != 400) {
    }
  }

  const saveChanges = async () => {
    offersContext.updateOfferCart(cart, !_.isEqual(offerCart, cart))
    setOpen(false)
  }

  useEffect(() => {
    const warnings = offersContext.checkCoveragesViolations(cart)
    warnings !== undefined && setOfferCartWarnings(warnings)
    addOnCoverages.forEach(element => {
      if (cart[element.coverageName] === undefined) {
        cart[element.coverageName] = element.coverageOptionId
      }
    })
    requestOffer(cart, startTime, billingPeriod, offersContext.options)
  }, [cart])

  return (
    <>
      {Object.keys(cart).length > 0 && Object.keys(options).length > 0 && (
        <div className="plan-edit-card">
          <header style={{ height: '4.25rem' }}>
            <div>Edit plan limits</div>
            <svg
              onClick={() => setOpen(false)}
              style={{ cursor: 'pointer' }}
              width="18"
              height="18"
              viewBox="0 0 18 18"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 7.34 2.004.344a1.174 1.174 0 0 0-1.66 1.66L7.34 9 .344 15.996a1.174 1.174 0 0 0 1.66 1.66L9 10.66l6.996 6.996a1.174 1.174 0 0 0 1.66-1.66L10.66 9l6.996-6.996a1.174 1.174 0 0 0-1.66-1.66L9 7.34z"
                fill="#2D2D2D"
                fillRule="nonzero"
              />
            </svg>
          </header>
          <div className="body">
            <div className="flex">
              <ShieldIcon />
              <div className="section-title">Policy Coverages</div>
            </div>
            <div className="margin-top-basic">
              {policyCoverageOrder.map(covName => {
                let coverageOptionId = cart[covName]
                let needToIgnore = false
                if (covName in coveragesToIgnore) {
                  needToIgnore = coveragesToIgnore[covName].ignoreInCustomize
                }
                if (!needToIgnore && !!coverageOptionId) {
                  return (
                    <div key={covName} style={{ marginBottom: '2rem' }}>
                      <SectionSpecialSelect
                        fullWidth={true}
                        onChange={onPolicyFieldChange}
                        name={covName}
                        errors={cartErrors['policy']}
                        warnings={Object.keys(cartErrors).length == 0 && cartWarnings[covName]}
                        value={coverageOptionId}
                        buttons={options[covName]}
                        title={PolicyCoveragesMapping[covName].title}
                        isPolicyManagment={false}
                        shouldHaveDivider={false}
                        tooltip={getCoverageTooltip(covName, options)}
                        Popover={() => (
                          <Tooltip text={getCoverageTooltip(covName, options)}>
                            <HelpIcon />
                          </Tooltip>
                        )}
                      />
                    </div>
                  )
                }
              })}
            </div>
            <Divider />
            <div className="flex flex-col">
              <div className="flex">
                <MotorcycleIcon />
                <div className="section-title">Motorcycle Coverages</div>
              </div>
              <div>
                {policyCoverageThatUnderMotorcyclesOrder.map(covName => {
                  let coverageOptionId = cart[covName]
                  let needToIgnore = false
                  if (covName in coveragesToIgnore) {
                    needToIgnore = coveragesToIgnore[covName].ignoreInCustomize
                  }
                  if (!needToIgnore && !!coverageOptionId) {
                    return (
                      <>
                        <SectionSpecialSelect
                          fullWidth={true}
                          onChange={onPolicyFieldChange}
                          name={covName}
                          errors={cartErrors['policy']}
                          warnings={Object.keys(cartErrors).length == 0 && cartWarnings[covName]}
                          value={coverageOptionId}
                          buttons={options[covName]}
                          title={PolicyCoveragesMapping[covName].title}
                          isPolicyManagment={true}
                          shouldHaveDivider={false}
                          tooltip={Object.keys(options).length > 0 && getCoverageTooltip(covName, options)}
                          Popover={() => (
                            <Tooltip text={Object.keys(options).length > 0 && getCoverageTooltip(covName, options)}>
                              <HelpIcon />
                            </Tooltip>
                          )}
                        />
                      </>
                    )
                  }
                })}
              </div>
              <div>
                {Object.keys(cart.vehicle_requests).length > 0 &&
                  vehicles.map((motorcycle, index) => {
                    return (
                      <div key={index}>
                        <div className="text-small margin-top-basic margin-bottom-basic">
                          {motorcycle.year} | {motorcycle.make} | {motorcycle.model}{' '}
                        </div>
                        <MotorcycleCoveragesForm
                          onChange={onMotorcycleChange}
                          onDiminishingDeductibleChange={onDiminishingDeductibleChange}
                          isNewFlow={sessionContext.newPaymentFlow}
                          isDiminishingDeductible={cart.vehicle_requests[motorcycle.id].is_diminishing_deductible}
                          values={cart.vehicle_requests[motorcycle.id].coverages}
                          options={options}
                          errors={cartErrors[motorcycle.id]}
                          motorcycleId={motorcycle.id}
                          needTooltip={true}
                          isPolicyManagment={false}
                          shouldHaveDivider={false}
                          popover={text => (
                            <Tooltip text={text}>
                              <HelpIcon />
                            </Tooltip>
                          )}
                        />
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
          <footer>
            {offerPriceBreakdown && offerPriceBreakdown.totalAmount && (
              <TotalCard
                vehiclesDetailes={vehicleDetails}
                pricebreakdown={offerPriceBreakdown}
                billingPeriod={billingPeriod}
                billingFlowType={offersContext.billingFlowType}
              />
            )}
            <div style={{ height: '7rem' }}>
              <div style={{ padding: '1rem .5rem', borderTop: 'solid 1px #e5dfd8' }}>
                <button className="save-btn" onClick={saveChanges} disabled={Object.keys(cartErrors).length > 0}>
                  Save changes
                </button>
              </div>
            </div>
          </footer>
        </div>
      )}
    </>
  )
}
